import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IEmailActionTypes } from "../../action-types/email/IEmailActionTypes";
import { IEmailReducer } from "../../page-state-model/email/IEmailReducer";
const iniState: IEmailReducer = {
    emails: [],
    status: ePageBaseStatus.is_not_initialization,
    emailEditing: undefined,
    isShowEditModal: false,
    isShowDetailApproveModal: false,
    emailSelectedIds: [],
    trangThaiEmailSelectedIds: [],
    emailApproveSelectedIds: []
}
export const emailReducer = (state: IEmailReducer = iniState, action: IEmailActionTypes): IEmailReducer => {
    switch (action.type) {
        case "EMAIL_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "EMAIL_LOAD_SUCCCES":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emails: action.payload
            }
        case "EMAIL_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emails: []
            }
        case "EMAIL_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                emailEditing: action.payload
            }
        case "EMAIL_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                emailEditing: undefined

            }
        case "EMAIL_CHANGE_SELECTED_IDS":
            return {
                ...state,
                emailSelectedIds: action.payload
            }
        case "EMAIL_CHANGE_APPROVE_SELECTED_IDS":
            return {
                ...state,
                emailApproveSelectedIds: action.payload
            }
        case "EMAIL_CHANGE_TRANGTHAI_SELECTED_IDS":
            return {
                ...state,
                trangThaiEmailSelectedIds: action.payload
            }
        case "EMAIL_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "EMAIL_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                isShowEditModal: false
            }
        case "EMAIL_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "EMAIL_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "EMAIL_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "EMAIL_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "EMAIL_SHOW_APPROVE_MODAL":
            return {
                ...state,
                isShowApproveModal: true
            }
        case "EMAIL_CLOSE_APPROVE_MODAL":
            return {
                ...state,
                isShowApproveModal: false,
            }
        case "EMAIL_SHOW_REJECT_MODAL":
            return {
                ...state,
                isShowRejectModal: true
            }
        case "EMAIL_CLOSE_REJECT_MODAL":
            return {
                ...state,
                isShowRejectModal: false,
            }
        case "EMAIL_APPROVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "EMAIL_APPROVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowApproveModal: false

            }
        case "EMAIL_APPROVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "EMAIL_REJECT_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "EMAIL_REJECT_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowRejectModal: false

            }
        case "EMAIL_REJECT_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "EMAIL_SHOW_DETAIL_APPROVE_MODAL":
            return {
                ...state,
                isShowDetailApproveModal: true
            }
        case "EMAIL_CLOSE_DETAIL_APPROVE_MODAL":
            return {
                ...state,
                isShowDetailApproveModal: false,
            }
        default:
            return state;
    }
}